import { render } from "./ResetPasswordValidation.vue?vue&type=template&id=5ed9a5e8"
import script from "./ResetPasswordValidation.vue?vue&type=script&lang=js"
export * from "./ResetPasswordValidation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__